import { useQuery } from "@tanstack/react-query";
import { getBankingAuthCheckExpiration } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const BANKING_AUTHS_EXPIRATION_QUERY_KEY =
  "BANKING_AUTHS_EXPIRING_ENVIRONMENTS";

export const bankingAuthExpirationKeys = {
  all: [BANKING_AUTHS_EXPIRATION_QUERY_KEY],
};

type Params = {
  enabled?: boolean;
};

export const useGetBankingAuthExpiration = ({ enabled }: Params = {}) =>
  useQuery({
    queryKey: bankingAuthExpirationKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getBankingAuthCheckExpiration(),
    ),
    staleTime: MS_TIME.hour,
    enabled,
  });
